/**
 *
 * Routes
 *
 * Array of all app routes to feed into react-router Route
 */
import {Role} from "../utils/roles";
import Constants from "../utils/constants";
import HomePage from "./components/HomePage";
import LoginPage from "./components/LoginPage";
import ForgotPasswordPage from "./components/login/ForgotPasswordPage";
import ResetPasswordPage from "./components/login/ResetPasswordPage";
import UsersPage from "./components/UsersPage";
import UsersNewOrEdit from "./components/UsersNewOrEdit";
import NotFound from "./components/layout/NotFound";
import PatrimoinePage from "./components/PatrimoinePage";
import PatrimoineImportPage from "./components/PatrimoineImportPage";
import PatrimoineDetailPage from "./components/PatrimoineDetailPage";
import ProblemsPage from "./components/ProblemsPage";
import ProblemsNewOrEdit from "./components/ProblemsNewOrEdit";
import FormsPage from "./components/FormsPage";
import FormsNewOrEdit from "./components/FormsNewOrEdit";
import LaveusesPage from "./components/LaveusesPage";
import LaveusesNewOrEdit from "./components/LaveusesNewOrEdit";
import CampaignsPage from "./components/CampaignsPage";
import CampaignsNewOrEdit from "./components/CampaignsNewOrEdit";
import InterventionsPage from "./components/InterventionsPage";
import SynthesePage from "./components/SynthesePage";
import PatrimoineNewOrEdit from "./components/PatrimoineNewOrEdit";
import LoginPageNew from "./components/LoginPageNew";
import CampaignUpdate from "./components/CampaignUpdate";
import DashboardPage from "./components/DashboardPage";
import InterventionsFormPage from "./components/InterventionsFormPage";

const Routes = [
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_HOME,
        roles: [],
        element: <HomePage/>,
    },
    {
        exact: true,
        protected: false,
        path: Constants.APP_ROUTE_LOGIN,
        roles: [],
        element: <LoginPageNew/>,
    },
    {
        exact: true,
        protected: false,
        path: Constants.APP_ROUTE_FORGOT_PASSWORD,
        roles: [],
        element: <ForgotPasswordPage/>,
    },
    {
        exact: true,
        protected: false,
        path: Constants.APP_ROUTE_RESET_PASSWORD,
        roles: [],
        element: <ResetPasswordPage/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_ADMIN_USERS_NEW,
        roles: [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT],
        element: <UsersNewOrEdit/>,
    },
    {
        exact: true,
        protected: true,
        tiles: true,
        tilesLabel: 'Tableau de bord',
        tilesEnabled: true,
        path: Constants.APP_ROUTE_DASHBOARD,
        roles: [Role.ROLE_EXPLOITANT],
        element: <DashboardPage/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_ADMIN_USERS_EDIT,
        roles: [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT],
        element: <UsersNewOrEdit/>,
    },
    {
        exact: true,
        protected: true,
        tiles: true,
        tilesLabel: 'Patrimoine',
        tilesEnabled: true,
        path: Constants.APP_ROUTE_PATRIMOINE,
        roles: [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT, Role.ROLE_CLIENT],
        element: <PatrimoinePage/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_PATRIMOINE_NEW,
        roles: [Role.ROLE_ADMIN],
        element: <PatrimoineNewOrEdit/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_PATRIMOINE_EDIT,
        roles: [Role.ROLE_ADMIN],
        element: <PatrimoineNewOrEdit/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_PATRIMOINE_IMPORT,
        roles: [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT],
        element: <PatrimoineImportPage/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_PATRIMOINE_DETAIL,
        roles: [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT, Role.ROLE_CLIENT],
        element: <PatrimoineDetailPage/>,
    },
    {
        exact: true,
        protected: true,
        tiles: true,
        tilesLabel: 'Problèmes',
        tilesEnabled: true,
        path: Constants.APP_ROUTE_ADMIN_PROBLEMS,
        roles: [Role.ROLE_ADMIN],
        element: <ProblemsPage/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_ADMIN_PROBLEMS_NEW,
        roles: [Role.ROLE_ADMIN],
        element: <ProblemsNewOrEdit/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_ADMIN_PROBLEMS_EDIT,
        roles: [Role.ROLE_ADMIN],
        element: <ProblemsNewOrEdit/>,
    },
    {
        exact: true,
        protected: true,
        tiles: true,
        tilesLabel: 'Formulaires',
        tilesEnabled: true,
        path: Constants.APP_ROUTE_ADMIN_FORMS,
        roles: [Role.ROLE_ADMIN],
        element: <FormsPage/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_ADMIN_FORMS_NEW,
        roles: [Role.ROLE_ADMIN],
        element: <FormsNewOrEdit/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_ADMIN_FORMS_EDIT,
        roles: [Role.ROLE_ADMIN],
        element: <FormsNewOrEdit/>,
    },
    {
        exact: true,
        protected: true,
        tiles: false,
        tilesLabel: 'Laveuses',
        tilesEnabled: true,
        path: Constants.APP_ROUTE_ADMIN_LAVEUSES,
        roles: [Role.ROLE_EXPLOITANT],
        element: <LaveusesPage/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_ADMIN_LAVEUSES_NEW,
        roles: [Role.ROLE_EXPLOITANT],
        element: <LaveusesNewOrEdit/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_ADMIN_LAVEUSES_EDIT,
        roles: [Role.ROLE_EXPLOITANT],
        element: <LaveusesNewOrEdit/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_ADMIN_CAMPAIGNS_NEW,
        roles: [Role.ROLE_EXPLOITANT],
        element: <CampaignsNewOrEdit/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_ADMIN_CAMPAIGNS_EDIT,
        roles: [Role.ROLE_EXPLOITANT],
        element: <CampaignsNewOrEdit/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_ADMIN_CAMPAIGNS_UPDATE,
        roles: [Role.ROLE_EXPLOITANT],
        element: <CampaignUpdate/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_INTERVENTIONS,
        roles: [Role.ROLE_EXPLOITANT, Role.ROLE_ADMIN, Role.ROLE_CLIENT],
        element: <InterventionsPage/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_INTERVENTIONS_UNIPATRIMOINE,
        roles: [Role.ROLE_EXPLOITANT, Role.ROLE_ADMIN, Role.ROLE_CLIENT],
        element: <InterventionsPage/>,
    },
    {
        exact: true,
        protected: true,
        tiles: true,
        tilesLabel: 'Synthèse',
        tilesEnabled: true,
        path: Constants.APP_ROUTE_SYNTHESE,
        roles: [Role.ROLE_EXPLOITANT, Role.ROLE_ADMIN, Role.ROLE_CLIENT],
        element: <SynthesePage/>,
    },
    {
        exact: true,
        protected: true,
        path: Constants.APP_ROUTE_ADMIN_USERS,
        tiles: true,
        tilesLabel: 'Utilisateurs',
        tilesEnabled: true,
        roles: [Role.ROLE_ADMIN, Role.ROLE_EXPLOITANT],
        element: <UsersPage/>,
    },
    {
        exact: true,
        protected: true,
        tiles: true,
        tilesLabel: 'Tournées',
        tilesEnabled: true,
        path: Constants.APP_ROUTE_ADMIN_CAMPAIGNS,
        roles: [Role.ROLE_EXPLOITANT],
        element: <CampaignsPage/>,
    },
    {
        exact: true,
        protected: true,
        tiles: false,
        tilesLabel: 'InterventionForm',
        tilesEnabled: false,
        path: Constants.APP_ROUTE_ADMIN_INTERVENTIONS_FORM,
        roles: [Role.ROLE_EXPLOITANT],
        element: <InterventionsFormPage/>,
    },
    {protected: false, path: '', element: <NotFound/>},
];

export default Routes;